import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { MobileAvailabilityFilter } from "./component";

import { IStoreState } from "../../../../reducers/types";

import {
  getCurrentFilterPrice,
  getExperiencesMaxPrice,
  getExperiencesPopularTagsList,
  getFilteredDurationTimes,
  getFilteredPopularFeatures,
  getFilteredStartTimes,
  getFilteredTripAdvisorRating,
  getSortOption,
  getFiltersChangedSinceLastSearch,
  getExperiencesMinPrice,
  getPriceFiltersChangedSinceLastSearch,
  getActivitiesAvailabilityProperties,
} from "../../reducer";

import {
  resetFilterAndSort,
  setFilterDurationTimes,
  setFilterPopularFeatures,
  setFilterPrice,
  setFilterStartTimes,
  setFilterTripadvisorRating,
  setSortOption,
} from "../../actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  filteredTripAdvisorRating: getFilteredTripAdvisorRating(state),
  filteredStartTimes: getFilteredStartTimes(state),
  filteredDurationTimes: getFilteredDurationTimes(state),
  maxExperiencesPrice: getExperiencesMaxPrice(state),
  filteredPrice: getCurrentFilterPrice(state),
  experiencesPopularTagsList: getExperiencesPopularTagsList(state),
  popularFeatures: getFilteredPopularFeatures(state),
  sortOption: getSortOption(state),
  filtersChangedSinceLastSearch: getFiltersChangedSinceLastSearch(state),
  priceFiltersChangedSinceLastSearch:
    getPriceFiltersChangedSinceLastSearch(state),
  minExperiencesPrice: getExperiencesMinPrice(state),
  activitiesAvailabilityProperties: getActivitiesAvailabilityProperties(state),
});

const mapDispatchToProps = {
  setFilterTripadvisorRating,
  setFilterStartTimes,
  setFilterDurationTimes,
  setFilterPrice,
  setFilterPopularFeatures,
  setSortOption,
  resetFilterAndSort,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileAvailabilityFilterProps = ConnectedProps<typeof connector>;

export const ConnectedMobileAvailabilityFilter = withRouter(
  connector(MobileAvailabilityFilter)
);
